export default __webpack_public_path__ + "static/media/premier-league.937c965a.jpg";